import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Config } from '../models/config.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigDataService {

  private config = {
    apiUrl: `${environment.PROTOCOL}://${environment.CONFIG_MANAGER_API_URL}:${environment.CONFIG_MANAGER_API_PORT}/api/v1`
  }

  readonly RESERVED_NEW_CONFIG_KEY = 'new-config-key';

  constructor(private http: HttpClient) { }

  getAllConsumerKeys() {
    return this.http.get<string[]>(`${this.config.apiUrl}/consumerKeys`);
  }

  getConfigsForConsumerKey(params: { consumerKey: string }) {
    return this.http.get<Config[]>(`${this.config.apiUrl}/config/list`, { params });
  }

  getConfig(params: { consumerKey: string, configKey: string }) {
    return this.http.get<Config>(`${this.config.apiUrl}/config`, { params });
  }

  postConfig(params: { consumerKey: string, configKey: string, extension: string }, body) {
    return this.http.post<Config>(`${this.config.apiUrl}/config/upload`, body, { params });
  }
}
